<selected-project-list-controller class="flex-none"></selected-project-list-controller>
<div class="relative w-full h-full flex flex-col gap-2 px-2">
  <button class="w-full py-1 bg-[#0047FF] text-white rounded" (click)="onClickGoCreatePresetBtn()">
    Go Create Preset
  </button>
  @if (embedData) {
    @if (embedData.projects) {
      @if (embedData.projects[this.selectedProjectIndex]) {
        <p class="text-gray-800 dark:text-white font-semibold text-sm lg:text-lg">
          Selected Presets
        </p>
        <div class="relative w-full flex flex-col gap-2">
          @for (
            selectedPreset of embedData.projects[this.selectedProjectIndex].presets;
            track selectedPreset
          ) {
            <div class="preset-field">
              <button class="w-full h-full">
                <img [src]="selectedPreset.thumbnail" [alt]="selectedPreset.title" />
              </button>
              <div class="preset-title-card">
                <div class="max-w-20 flex flex-row gap-1 items-center">
                  @if (isMainPreset(selectedPreset)) {
                    <div class="flex-none w-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 -960 960 960"
                        fill="#FFE234"
                      >
                        <path
                          d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z"
                        />
                      </svg>
                    </div>
                  }
                  <p>{{ selectedPreset.title }}</p>
                </div>
                <div class="w-full flex flex-row justify-between">
                  <div></div>
                  <div class="relative flex flex-row gap-2">
                    @if (!isMainPreset(selectedPreset)) {
                      <button class="delete-button" (click)="clickAddMainPreset(selectedPreset)">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 -960 960 960"
                          fill="#FFE234"
                        >
                          <path
                            d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z"
                          />
                        </svg>
                      </button>
                    }
                    <button class="delete-button" (click)="clickSelectedPreset(selectedPreset)">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="red">
                        <path
                          d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <p class="text-gray-800 dark:text-white font-semibold text-sm lg:text-lg">Presets</p>
        <div class="relative w-full flex flex-col gap-2">
          @for (preset of presetList; track preset) {
            <div class="preset-field">
              <button class="w-full h-full">
                <img [src]="preset.thumbnail" [alt]="preset.title" />
              </button>
              <div class="preset-title-card">
                <p class="max-w-20">{{ preset.title }}</p>
                <div class="w-full flex flex-row justify-between">
                  <div></div>
                  <button class="delete-button" (click)="clickPreset(preset)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="black">
                      <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
  }
</div>
